export const DEFAULT_IMAGE_PROPS = {
    alt: '',
    src: '',
    decorative: false,
    displayPopupTitle: false,
    role: 'presentation',
};
